import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Terms = () => {
    const [loading, setLoading] = useState(true);
    const [termsData, setTermsData] = useState([]);

    const fetchTermsData = () => {
        axios.post(API_URL.TERMS_LIST, {}).then(
            (res) => {
                if (res.data.status === 1) {
                    setTermsData(res.data.data);
                }
                setLoading(false);
                if (sessionStorage.getItem("pId")) {
                    let rId = "row-" + JSON.parse(sessionStorage.getItem("pId"));
                    setTimeout(() => {
                        scrollToRow(rId);
                    }, 100);
                }
            },
            (error) => {
                setLoading(false);
                toast.error("Something went wrong..", {
                    autoClose: 3000,

                });
            }
        );
    };

    const deleteState = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this - " + row.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(API_URL.TERMS_DELETE, { id: row.id }).then(
                    (res) => {
                        if (res.data.status === 1) {
                            let newData = termsData.filter((r) => r.id != row.id);
                            setTermsData(newData);
                            toast.success("Delete Successfully", { autoClose: 3000 });
                        } else {
                            toast.error(res.data.data, { autoClose: 3000 });
                        }
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        toast.error("Something went wrong..", { autoClose: 3000 });
                    }
                );
            }
        });
    };

    const scrollToRow = (rowId) => {
        const rowElement = document.getElementById(rowId);
        if (rowElement) {
            rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };
    
    useEffect(() => {
        fetchTermsData();
    }, []);
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>
                        Terms
                        <small className="me-2">({termsData.length})</small>
                    </h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/settings/terms/add"} className="btn btn-primary">
                            <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
                            Terms
                        </Link>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body p-0">
                            {loading && <Loader></Loader>}
                            {!loading && (
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className="">
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th className="text-center" style={{ width: "200px" }}>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {termsData.map((row, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td style={{ width: "10px" }}>{key + 1}</td>
                                                        <td>
                                                            {row.name}
                                                        </td>
                                                        <td
                                                            className="d-flex justify-content-center gap-2"
                                                            style={{ width: "200px" }}
                                                        >
                                                            <Link
                                                                to={"/settings/terms/edit/" + row.id}
                                                                className="btn btn-sm btn-secondary mr-2"
                                                            >
                                                                <i className="fa fa-edit me-1"></i> Edit
                                                            </Link>
                                                            <button
                                                                onClick={() => deleteState(row)}
                                                                className="btn btn-sm btn-danger"
                                                            >
                                                                <i className="fa fa-trash me-1"></i> Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Terms;
